import defaultState from "./state";

const filtroBusquedaSEReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SE/FILTRO_BUSQUEDA":
      return Object.assign({}, state, defaultState);

    case "SE/CARGAR_PRESTACIONES": {
      return Object.assign({}, state, {
        loading: false,
        prestaciones: action.prestaciones,
      });
    }

    case "SE/CARGAR_SOLICITUDES": {
      return Object.assign({}, state, {
        loadingSolicitudes: false,
        solicitudes: action.solicitudes.map((s) => ({
          IdSolicitudEspecial: s.IdSolicitudEspecial,
          FechaCreacion: s.FechaCreacion,
          IdEstadoSE: s.IdEstadoSE,
          EstadoSE: s.EstadoSE,
          IdSolicitud: s.IdSolicitud,

          IdSolicitudEspecialPadre: s.IdSolicitudEspecialPadre,
          FechaCreacionPadre: s.FechaCreacionPadre,
          IdEstadoSEPadre: s.IdEstadoSEPadre,
          EstadoSEPadre: s.EstadoSEPadre,
          IdSolicitudPadre: s.IdSolicitudPadre,

          IdSolicitudEspecialHijo: s.IdSolicitudEspecialHijo,
          FechaCreacionHijo: s.FechaCreacionHijo,
          IdEstadoSEHijo: s.IdEstadoSEHijo,
          EstadoSEHijo: s.EstadoSEHijo,
          IdSolicitudHijo: s.IdSolicitudHijo,

          IdSolicitudHomologa: Number(s.IdSolicitudHomologa),
        })),
      });
    }

    case "SE/CARGAR_TIPOS_ATENCION": {
      return Object.assign({}, state, {
        //loading: false,
        tiposAtencion: action.tiposAtencion,
        filtros: {
          tipoAtencion: "0",
        },
      });
    }

    case "SE/CAMBIAR_TIPO_ATENCION": {
      const filtros = Object.assign({}, state.filtros, {
        tipoAtencion: action.tipoAtencion,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "SE/GET_SIZE_ARCHIVO": {
      //console.log(">>>>>>>>>>>>>>> ACTION >>>>>>>>>>>>>>");
      //console.log(action);

      return Object.assign({}, state, {
        sizeArchivo: action.sizeArchivo,
      });
    }

    case "SE/LOADING": {
      return Object.assign({}, state, {
        loading: action.loading,
      });
    }

    case "SE/LOADINGFILE": {
      return Object.assign({}, state, {
        loadingFile: action.loadingFile,
      });
    }

    case "SE/LOADING_SOLICITUDES": {
      return Object.assign({}, state, {
        loadingSolicitudes: action.value,
      });
    }

    case "SE/LOADING_ERRORES": {
      return Object.assign({}, state, {
        loadingErrores: action.value,
      });
    }

    case "SE/CARGAR_ERRORES": {
      return Object.assign({}, state, {
        loadingErrores: false,
        errores: action.errores.map((s) => ({
          Fila: s.Fila,
          Columna: s.Columna,
          Errores: s.Errores,
        })),
      });
    }

    default:
      return state;
  }
};

export default filtroBusquedaSEReducer;



// WEBPACK FOOTER //
// ./src/components/SolicitudesEspeciales/FiltroBusqueda/reducer.js